import { Portal } from '@headlessui/react';
import { motion } from 'framer-motion';
import React from 'react';
import Spinner from './Spinner';
import Alert from './Alert';

const FullScreenLoaderConfirm = ({ loading, needToConfirm, hasClickedConfirm, label, children }) => {
  if (!loading && !needToConfirm) return <> </>;

  return (
    <Portal>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className='fixed z-[9999] bg-gray-900/95 inset-0 w-full h-full flex items-center justify-center flex-col gap-5 px-4'
      >
        <div className='flex flex-col justify-center items-center gap-10'>
          {needToConfirm ? (
            <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' className='w-[100px]'>
              <path
                d='M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z'
                fill='currentColor'
              />
            </svg>
          ) : (
            <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 576 512' className='w-[100px]'>
              <path
                d='M352 32H224V66.3 176L159.6 85.8C84.1 121.8 32 198.8 32 288v64H544l0-66.4c-.9-88.1-52.8-164.1-127.5-199.8L352 176V66.3 32zM0 408s80 72 288 72s288-72 288-72V384H0v24z'
                fill='currentColor'
              />
            </svg>
          )}
          {!needToConfirm && <Spinner />}
          <p className='text-2xl font-medium max-w-sm mx-auto text-center'>{label}</p>

          {loading && (
            <Alert type='warning' className='text-center'>
              <span>Please do not refresh or close the page while the City Builder is loading.</span>
            </Alert>
          )}
        </div>

        {children}
      </motion.div>
    </Portal>
  );
};

export default FullScreenLoaderConfirm;
